import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTextFormatUnderline20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconTextFormatUnderline20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M4.75 3H4v3.018a.75.75 0 0 0 1.5 0V4.5h3.52V12H7.486a.75.75 0 0 0 0 1.5H12a.75.75 0 0 0 0-1.5h-1.48V4.5H14v1.518a.75.75 0 0 0 1.5 0V3zm-.182 12.552a.75.75 0 0 0 0 1.5h10.906a.75.75 0 0 0 0-1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTextFormatUnderline20);
